var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTopPoly(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 470,
    height: 119,
    viewBox: "0 0 470 119",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.37451 3.50006L256.026 3.49999L461.625 3.50008L351.037 115.5L118.963 115.5L8.37451 3.50006Z",
    fill: "url(#paint0_linear_22_274)",
    stroke: "black",
    strokeWidth: 7
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_22_274",
    x1: 470,
    y1: 0,
    x2: 470,
    y2: 119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#001C31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445,
    stopColor: "#002846"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585,
    stopColor: "#002846"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#001C31"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopPoly);
export default __webpack_public_path__ + "static/media/TopPoly.6d04f862d48ddc45c8ea976a0c936874.svg";
export { ForwardRef as ReactComponent };